import React,{useState} from 'react'
import authQueries from '../../queries/authQueries';
import { useFormContext } from '../../Context/FormContext';
import { Spin, } from 'antd';

const CallBack = ({navTab, setNavTab}) => {

  const { formData, updateFormData, formResponse, updateFormResponse } = useFormContext();

  const [loading, setLoading] = useState(false);

  const [isButtonDisabled, setIsButtonDisabled] = useState(false);

  const Interested = () => {

    updateFormData({ callback: 'YES', platform:"WEB", })

    setNavTab(navTab + 1)
    
  }



  const Compliant  = authQueries.useCompliantMutation(
  
    (response) => {
    
      if(response?.message === "Success") {

        updateFormResponse(response.data)

        setLoading(false)

        setIsButtonDisabled(false)
  
        console.log("Data Saved successfully")
  
        setNavTab(navTab + 2)
  
      }

      else {
        alert("Error found. Please Try again")
        setIsButtonDisabled(false)
        setNavTab(navTab)
        setLoading(false)
        return false
      }

  });
  
  const onSubmit = () => {
    setLoading(true)
    setIsButtonDisabled(true)

    const Datas = {
      callback: 'NO',
      platform:"WEB",
      ...formData
   } 

    const datavalues = {
      data : JSON.stringify(Datas),
      code: formData?.employer_code
    }
  
    Compliant.mutateAsync(datavalues);
  
  }

  return (

    <div>

      <Spin spinning={loading} size='large'>

        <div className="tab-pane verification-wrpr">
            
          <div className="main-hding"><strong>Are you interested to receive a call back from ShipConRep</strong></div>
            
            <div className="row">
                  
              <div className="col-md-12 text-center pb-5">
                    
                  <button className="btn btn-primary btn-informant btn-interested gotoStp8" onClick={() => Interested()}>I'm Interested <i className="icon-check"></i></button>
                    
                  <button disabled={isButtonDisabled} className="btn btn-primary btn-informant btn-not-interested" onClick={() => onSubmit()}>I'm Not Interested <i className="icon-close"></i></button>
                    
              </div>
                    
            </div>
              
        </div>  

      </Spin>

    </div>

  )

}

export default CallBack
